import type { BoxProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import type { Ref } from 'react';

export interface FullBoxRootProps extends BoxProps {
  column?: boolean;
  ref?: Ref<HTMLElement | null>;
}

export function FullBoxRoot({ column, ref, ...props }: FullBoxRootProps) {
  return (
    <Box
      className="FullBoxRoot"
      display="flex"
      flexDirection={column ? 'column' : 'row'}
      h={column ? '100%' : 'auto'}
      ref={ref}
      {...props}
    ></Box>
  );
}

export interface FullBoxAsideProps extends BoxProps {
  ref?: Ref<HTMLElement | null>;
}

export function FullBoxAside({ ref, ...props }: FullBoxAsideProps) {
  return <Box className="FullBoxAside" flex="0 0 auto" ref={ref} {...props}></Box>;
}

export interface FullBoxMainProps extends BoxProps {
  ref?: Ref<HTMLElement | null>;
}

export function FullBoxMain({ ref, ...props }: FullBoxMainProps) {
  return (
    <Box
      className="FullBoxMain scrollHover"
      flex="1 1 auto"
      overflow="auto"
      ref={ref}
      {...props}
    ></Box>
  );
}
